import useLegal from "./legal"
const useScreenHooks = () => {
    return {
        useLegal
    };
  };
  
  export default useScreenHooks;